var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('prismic-rich-text',{staticClass:"slice-richtext content is-custom mb-24px",attrs:{"field":_vm.fragment.primary.richtext_content}})}
var staticRenderFns = []

export { render, staticRenderFns }